var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148677",
    "data-name": "Rectangle 148677",
    width: 24,
    height: 24,
    transform: "translate(1105 439)",
    fill: "#0c0c0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view",
    transform: "translate(-1105 -439)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "view-2",
    "data-name": "view",
    transform: "translate(1106.973 444.662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11836",
    "data-name": "Group 11836",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11835",
    "data-name": "Group 11835",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_50",
    "data-name": "Subtraction 50",
    d: "M10.026,12.679C4.563,12.679.282,6.9.1,6.651a.53.53,0,0,1,0-.626,18.836,18.836,0,0,1,2.983-3.1A14.426,14.426,0,0,1,6.2.908,9.062,9.062,0,0,1,10.026,0a9.093,9.093,0,0,1,3.881.934,14.7,14.7,0,0,1,3.142,2.057,19.045,19.045,0,0,1,2.9,3.037.524.524,0,0,1,0,.623,18.9,18.9,0,0,1-2.984,3.105,14.535,14.535,0,0,1-3.116,2.015A9.062,9.062,0,0,1,10.026,12.679Zm0-11.626A9.446,9.446,0,0,0,4.479,3.177,18.81,18.81,0,0,0,1.273,6.246L1.2,6.338l.077.093A18.991,18.991,0,0,0,4.485,9.5a9.414,9.414,0,0,0,5.541,2.124A9.427,9.427,0,0,0,15.576,9.5a18.744,18.744,0,0,0,3.206-3.068l.076-.093-.076-.09A18.888,18.888,0,0,0,15.57,3.177,9.427,9.427,0,0,0,10.026,1.053Z",
    fill: "#0c0c0b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11838",
    "data-name": "Group 11838",
    transform: "translate(6.145 2.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11837",
    "data-name": "Group 11837",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_51",
    "data-name": "Subtraction 51",
    d: "M3.883,7.761a3.88,3.88,0,1,1,3.88-3.88A3.886,3.886,0,0,1,3.883,7.761Zm0-6.7A2.826,2.826,0,1,0,6.708,3.881,2.827,2.827,0,0,0,3.883,1.057Z",
    fill: "#0c0c0b"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6363c3b7.svg";
export { ForwardRef as ReactComponent };